import { SelectedItemTheme } from "@components/atoms/Button/types";
import { ProductCategory } from "@utils/constants";

export enum cpsSectionNames {
  cut = "Cut",
  polish = "Polish",
  symmetry = "Symmetry",
}

export enum cpsValues {
  cps = "cps",
  three_vg_plus = "three_vg_plus",
  three_x = "three_x",
  eight_x_option = "eight_x",
  ideal = "Ideal",
  excellent = "Excellent",
  very_good = "Very Good",
  eight_x = "8X",
  excellentIdeal = "Ex/Ideal",
}

export enum sectionTitleList {
  cpsTitle = "Cut, Polish, Symmetry",
  three_vg_plus_title = "3VG+",
  three_x_title = "3X",
  three_x_title_plus = "3X+",
  eight_x_title = "8X",
}

export enum CPSSubsectionNames {
  CPS = "CPS",
}

export type TextBoxSectionProps = {
  options: Array<any>;
  columns: number;
  selectionType?: string;
  displayedRows?: number;
  sectionTitle: string;
  payloadName: Array<string>;
  parentPayloadName: Array<string>;
  value?: Array<any>;
  sectionName?: string;
  selectedStyle: SelectedItemTheme;
  isSubOption: boolean;
  hasSeparator?: boolean;
  translation: any;
  subSectionName: string;
  expandView?: any;
  direction?: string;
  minWidth?: number;
  fromUnifiedFilters?: boolean;
  selectedProduct: ProductCategory;
  justifyContent?: string;
  isCollapsible?: boolean;
  dependencies?: Array<{ key: string; value: any }>;
};

export const cpsSections = [
  cpsSectionNames.cut,
  cpsSectionNames.polish,
  cpsSectionNames.symmetry,
  sectionTitleList.cpsTitle,
];
